import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SeasonTableComponent} from './season-table.component';
import {SeasonTableEntryComponent} from './season-table-entry/season-table-entry.component';
import {ImageVariantModule} from '@tisa-group/core';
import {SeasonTableLastFiveMatchesComponent} from './season-table-last-five-matches/season-table-last-five-matches.component';
import {SeasonTableLiveMatchResultComponent} from './season-table-live-match-result/season-table-live-match-result.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    SeasonTableComponent,
    SeasonTableEntryComponent,
    SeasonTableLastFiveMatchesComponent,
    SeasonTableLiveMatchResultComponent,
  ],
  exports: [SeasonTableComponent],
  imports: [CommonModule, ImageVariantModule, TranslateModule],
})
export class SeasonTableModule {}
